<mat-table #table [dataSource]="dataSource">
  <ng-container matColumnDef="Name">
    <mat-header-cell *matHeaderCellDef>Navn</mat-header-cell>
    <mat-cell *matCellDef="let definition">{{definition.Name.NO}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="Type">
    <mat-header-cell *matHeaderCellDef>Type</mat-header-cell>
    <mat-cell *matCellDef="let definition">{{definition.Type | deviationTypeName}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="Context">
    <mat-header-cell *matHeaderCellDef>Kontekst</mat-header-cell>
    <mat-cell *matCellDef="let definition">{{definition.Context | deviationContextName}}</mat-cell>
  </ng-container>

  <mat-header-row hidden="{{headersVisible}} " *matHeaderRowDef="displayedColumns"></mat-header-row>

  <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="editDefinition.emit(row)"></mat-row>
</mat-table>
